var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.042 0l7.942 7.942L17.927 0l2.042 2.042-9.985 9.985L0 2.042z","fill":"#000","fillRule":"nonzero"}));
}

Arrow.defaultProps = {"width":"20","height":"12","viewBox":"0 0 20 12"};

module.exports = Arrow;

Arrow.default = Arrow;
